import { createStore } from "vuex";
import { actionTypes, commitTypes, dbName } from "./store-types";
import systemApi from "./api/systemApi";
import accountApi from "./api/accountApi";
import { loadPersistedState, clearPersistedState } from "./utils/persistedState";

// هنگام خروج، پاسخ‌های API که سرویس‌ورکر برای حالت آفلاین کش کرده پاک شوند
function clearOfflineApiCache() {
    try {
        if (typeof caches !== "undefined" && caches.delete) {
            caches.delete("bndbs-api-get");
        }
    } catch (e) {
        /* noop */
    }
}

const defaultUser = () => ({
    UserId: null,
    Role: null,
    FullName: null,
    MobileConfirmed: false,
    EmailConfirmed: false,
    AccessToken: null,
    RefreshToken: null,
});

const userProfile = () => ({
    BirthDate: null,
    Mobile: null,
    Email: null,
    UserName: null,
    FirstName: null,
    LastName: null,
    Avater: null,
    Address: null,
    Avatar: null,
    Bio: null,
    CodePostal: null,
    NationalCodeConfirmed: false,
    Organization: null,
    Phone: null,
    Side: null,
    TelPhoneConfirmed: false,
    ProvinceId: 0,
    CityId: 0,
});

const appConfig = () => ({
    AppId: 0,
    Version: 0,
    // توکن پاک‌سازی سراسری اجباری؛ سرور با تغییر مقدار آن همه‌ی کش‌های کلاینت را وادار به پاک‌سازی می‌کند
    PurgeToken: null,
    AppLink: null,
    LastUpdate: null,
    Required: false,
    MainDomain: null,
});

const userDashboard = () => ({
    WalletAmount: 0,
    ProfitAmount: 0,
    TicketCount: 0,
    TicketNewCount: 0,
    TicketTop: null,
    ServiceCount: 0,
    ActiveServiceCount: 0,
    InvoiceCount: 0,
    NewInvoiceCount: 0,
    InvoiceTop: null,
    Packages: null,
    ServiceType: null,
    BankAccounts: null
});

var ticketGroup = () => ({
    Name: null,
    Display: null,
    Tickets: {},
    CountNew: 0
});

export default createStore({
    state: {
        sidenav: true,
        user: defaultUser(),
        userProfile: userProfile(),
        signedIn: false,
        loginRedirect: null,
        config: appConfig(),
        province: null,
        notifications: null,
        dashboard: userDashboard(),
        ticketGroups: ticketGroup(),
        services: null,
        serviceType: null,
    },
    getters: {
        sidenav: state => state.sidenav,
    },
    mutations: {
        [commitTypes.SET_USER](state, user) {
            Object.assign(state.user, user);
            // احراز هویت با کوکی است؛ نشانه‌ی ورود = داشتن UserId (از پاسخ login یا Session).
            state.signedIn = !!(user && (user.UserId || user.AccessToken));
        },
        [commitTypes.SET_USER_PROFILE](state, userProfile) {
            Object.assign(state.userProfile, userProfile);
        },
        [commitTypes.SET_STATE](state, localState) {
            Object.assign(state, localState);
            // حدسِ اولیه از روی داده‌ی ذخیره‌شده؛ اعتبار واقعی در CHECK_TOKEN با کوکی بررسی می‌شود.
            state.signedIn = !!(state.user && state.user.UserId);
        },
        [commitTypes.SET_SETTINGS](state, config) {
            // state.config = config;
            Object.assign(state.config, config);
        },
        [commitTypes.SET_REDIRECT](state, val) {
            state.loginRedirect = val;
        },
        toggleSideNav: (state, value) => {
            if (typeof value === 'boolean') {
                state.sidenav = value;
                return;
            }
            state.sidenav = !state.sidenav;
        }
    },
    actions: {
        toggleSideNav({ commit }, value) {
            commit('toggleSideNav', value)
        },
        // initial data load from the server: paths, config info, lists, keys, etc
        [actionTypes.APP_LOAD]({ commit }) {
            return systemApi.appSettings().then(({ data }) => {
                commit(commitTypes.SET_SETTINGS, data);
            });
        },
        [actionTypes.SAVE_LOGIN]({ commit, state }, authInfo) {
            return new Promise((resolve) => {                
                let redirect = state.loginRedirect ? state.loginRedirect : { name: "Home", params: {} };                
                commit(commitTypes.SET_REDIRECT, null);

                if (!authInfo.MobileConfirmed) {
                    redirect = { name: 'UserConfirm', params: { id: authInfo.UserId } };
                }

                commit(commitTypes.SET_USER, authInfo);

                resolve(redirect);
            });
        },
        [actionTypes.CLEAR_LOGIN]({ commit, state }) {
            console.log("CLEAR_LOGIN");
            commit(commitTypes.SET_STATE, {
                sidenav: true,
                user: defaultUser(),
                userProfile: userProfile(),
                signedIn: false,
                loginRedirect: null,
                config: appConfig(),
                province: null,
                notifications: null,
                dashboard: userDashboard(),
                ticketGroups: ticketGroup(),
                services: null,
                serviceType: null,
            });
            clearPersistedState(dbName.DB_STATE);
            clearOfflineApiCache();
            return true; //accountApi.logout();
        },
        // اعتبار نشست همیشه از روی کوکی HttpOnly بررسی می‌شود (نه وجود توکن در JS).
        [actionTypes.CHECK_TOKEN]({ commit, dispatch }) {
            return accountApi
                .session()
                .then((r) => {
                    const data = r && r.data;
                    if (data && data.Status === 1 && data.UserId) {
                        commit(commitTypes.SET_USER, data);
                        return true;
                    }
                    return dispatch(actionTypes.CLEAR_LOGIN);
                })
                .catch((e) => {
                    const status = e && e.response && e.response.status;
                    // ۴۰۱ = نشست معتبر نیست → پاک کن. خطای شبکه/آفلاین → وضعیت را دست‌نخورده بگذار.
                    if (status === 401) {
                        return dispatch(actionTypes.CLEAR_LOGIN);
                    }
                    return false;
                });
        },
        [actionTypes.LOAD_LOCATION]({ commit, state }) {
            const localState = loadPersistedState(dbName.DB_STATE);
            if (
                localState &&
                localState.config &&
                localState.config.Version == state.config.Version
            ) {
                commit(commitTypes.SET_STATE, localState);
            }
            return Promise.resolve(true);
        },
        [actionTypes.LOAD_USER_DATA]({ commit, state }) {
            if (!state.signedIn) return Promise.resolve(false);
            return accountApi
                .userProfile()
                .then(({ data }) => {
                    commit(commitTypes.SET_USER_PROFILE, data);
                })
                .catch((e) => {
                    console.error(e);
                });
        },
        [actionTypes.SAVE_DATA]({ commit, state }) {
            return localStorage.setItem(dbName.DB_STATE, JSON.stringify(state));
        },
    }
})